"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthServerConnector = void 0;
const tslib_1 = require("tslib");
const AbstractConnector_1 = require("./AbstractConnector");
const providers_1 = require("../providers");
class AuthServerConnector extends AbstractConnector_1.AbstractConnector {
    constructor() {
        super();
        this.activate = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const account = this.provider.getAccount();
            if (!account) {
                throw new Error('Cannot activate the Auth Server Connector');
            }
            return {
                provider: this.provider,
                chainId: this.provider.getChainId(),
                account
            };
        });
        this.getProvider = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.provider;
        });
        this.getChainId = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.provider.getChainId();
        });
        this.getAccount = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.provider.getAccount();
        });
        this.provider = new providers_1.AuthServerProvider();
    }
    deactivate() {
        this.provider.deactivate();
    }
}
exports.AuthServerConnector = AuthServerConnector;
//# sourceMappingURL=AuthServerConnector.js.map